import { render } from "preact";
import LinksSection from "./LinkSection";
import LogoSection from "./LogoSection";
import { useEffect, useState } from "react";
import navbarApi from "./api";
import "./index.css";
import toast, { Toaster } from "react-hot-toast";
import { NavbarContext } from "./context";
import { ILink } from "./type";
import api from "./api";
import "sweetalert2/src/sweetalert2.scss";

const TToaster = Toaster as unknown as any;

function Card() {
  return (
    <div class="div-block-267">
      <LinksSection />
      <LogoSection />
    </div>
  );
}

function distructureQueryString(queryString: string) {
  const query = queryString.substring(1);
  const vars = query.split("&");
  const queryObj = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    queryObj[pair[0]] = decodeURIComponent(pair[1]);
  }
  return queryObj;
}

function App() {
  const [data, setData] = useState(null);
  const query = window.location.search;
  const { site_id } = distructureQueryString(query) as { site_id: string };
  const [loading, setLoading] = useState(true);

  const fetchNavbar = async (silent = false) => {
    !silent && setLoading(true);
    try {
      const res = await navbarApi.fetch(site_id);
      setData(res.data);
      setLoading(false);
    } catch (err) {
      toast.error("Error fetching navbar");
      setLoading(false);
    }
  };

  const createNavbar = async () => {
    setLoading(true);
    try {
      const payload = {
        body: {
          logo_type: "image",
          logo_image: "",
          logo_text: "",
          logo_emoji: "",
          logo_size: "40",
          height: "40",
          is_floating: false,
          background_color: "",
          color: "",
        },

        links: [],
        buttons: [],
      };

      await navbarApi.create(site_id, payload);
      fetchNavbar();
    } catch (err) {
      toast.error("Error fetching navbar");
      setLoading(false);
    }
  };

  const updateNavbar = async (input: any, silent = false) => {
    try {
      !silent && setLoading(true);
      const payload = {
        logo_size: input.logo_size ?? "40",
        height: input.height ?? "40",
        logo_type: input.logo_type ?? "image",
        logo_image: input.logo_image ?? "",
        logo_text: input.logo_text ?? "",
        logo_emoji: input.logo_emoji ?? "",
        is_floating: input.is_floating ?? false,
        background_color: input.background_color ?? "",
        color: input.color ?? "",

        ...input,
        links: input?.links ? input.links : data?.links || [],
        buttons: input?.buttons ? input.buttons : data?.buttons || [],
      };

      const response = await navbarApi.update(site_id, payload);
      setData(response.data);
      setLoading(false);
    } catch (err) {
      toast.error("Error fetching navbar");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNavbar();
  }, []);

  const saveNavbar = async (payload: any) => {
    if (data) {
      updateNavbar(payload);
    } else {
      await createNavbar();
      updateNavbar(payload);
    }
  };

  const saveLink = async (link: ILink) => {
    if (!data) await createNavbar();
    if (link.id > 0) {
      const links = data.links.map((l: ILink) => {
        if (l.id === link.id) return link;
        return l;
      });
      updateNavbar({ links: [...links] }, true);
    } else {
      const response = await api.createLink(site_id, link);
      setData({ ...data, links: [...data?.links, response.data as ILink] });
      fetchNavbar(true);
    }
  };

  const saveButton = async (button: any) => {
    if (!data) await createNavbar();
    if (button.id > 0) {
      const buttons = data.buttons.map((b: any) => {
        if (b.id === button.id) return button;
        return b;
      });
      updateNavbar({ buttons: [...buttons] }, true);
    } else {
      const response = await api.createButton(site_id, button);
      setData({ ...data, buttons: [...data?.buttons, response.data] });
      fetchNavbar(true);
    }
  };

  const { links, buttons, ...rest } = data || {};
  return (
    <>
      {!loading ? (
        <NavbarContext.Provider
          value={{
            links: links || [],
            buttons: buttons || [],
            logoData: {
              ...rest,

              logo_size: rest.logo_size || "40",
              height: rest.height || "40",
              logo_type: rest.logo_type || "image",
            },
            siteId: site_id,
            saveLink,
            saveButton,
            save: saveNavbar,
            refetch: fetchNavbar,
            update({ buttons, link, logoData }) {
              if (buttons) updateNavbar({ buttons: [...buttons] });

              if (link) updateNavbar({ links: [...links] });

              if (logoData) updateNavbar({ ...logoData });
            },
          }}
        >
          <TToaster />
          <Card />
        </NavbarContext.Provider>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
}

const el = document.querySelector("#navigation-card");

console.log("About to render navbar to the dom", el);
if (el) {
  console.log("rendering navbar");
  render(<App />, el as Element);
}
